import nexus from '@ospin/nexus'
import { removeNotifications } from '~/redux/actions/actions'

const callDeleteUserNotification = async (dispatch, userId, notificationId) => {
  await nexus.user.notifications.remove({ userId, notificationId })
  dispatch(removeNotifications({ ids: [notificationId] }))
}

export default callDeleteUserNotification
